webpackJsonp([15400075347947],{

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.privacyQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    padding: 20px;\n    \n    @media(min-width: 768px) {\n        padding: 20px 100px;\n    }\n    \n      @media(min-width: 1200px) {\n        padding: 20px 200px;\n    }\n    \n    h1 {\n      margin-bottom: 20px;\n    }\n'], ['\n    padding: 20px;\n    \n    @media(min-width: 768px) {\n        padding: 20px 100px;\n    }\n    \n      @media(min-width: 1200px) {\n        padding: 20px 200px;\n    }\n    \n    h1 {\n      margin-bottom: 20px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  p {\n     margin-bottom: 16px;\n\n    p{\n      text-align: left;\n      margin-bottom: 16px;\n    }\n  }\n'], ['\n  p {\n     margin-bottom: 16px;\n\n    p{\n      text-align: left;\n      margin-bottom: 16px;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(10);
	
	var _Kit = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var TextContainer = _styledComponents2.default.div(_templateObject2);
	
	var PrivacyPolicy = function PrivacyPolicy(props) {
	    var _props$data$privacy$e = props.data.privacy.edges[0].node,
	        title = _props$data$privacy$e.title,
	        content = _props$data$privacy$e.content;
	
	    return _react2.default.createElement(
	        _Container.HeroContainer,
	        null,
	        _react2.default.createElement(
	            Container,
	            null,
	            _react2.default.createElement(
	                _Kit.Title,
	                null,
	                title
	            ),
	            _react2.default.createElement(
	                TextContainer,
	                null,
	                _react2.default.createElement(_Kit.P2, {
	                    dangerouslySetInnerHTML: { __html: content }
	                })
	            )
	        )
	    );
	};
	
	exports.default = PrivacyPolicy;
	var privacyQuery = exports.privacyQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-policy-js-21a637ce860c3f567bd0.js